// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* 设置文字输入的高度，防止文字溢出 */\n.colStyle .cell {\r\n    height: 160px !important;\r\n    overflow-y: scroll !important;\n}\n.notcolStyle .cell {\r\n    height: 160px;\n}\r\n", ""]);
// Exports
module.exports = exports;
